import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetStripeCreditCard } from './useGetStripeCreditCard';

export { usePostClientAdminsCardRegistrations } from './usePostClientAdminsCardRegistrations';

type IUseContractInfoPaymentMethod = () => {
  state: {
    /** Stripe 既定カード情報。null = 未登録（404） */
    data: ReturnType<typeof useGetStripeCreditCard>['data'];
  };
};

/**
 * ご契約情報 お支払い方法のコンポーネントフック
 *
 * - threeLetterCode を Cookie から取得し、API hook に渡す
 */
export const useContractInfoPaymentMethod: IUseContractInfoPaymentMethod = () => {
  const threeLetterCode = getThreeLetterCode() ?? '';

  const { data } = useGetStripeCreditCard({ threeLetterCode });

  return {
    state: { data },
  };
};
